import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { CsIconModule } from "@components/icon";
import { ToolbarModule } from "@components/toolbar";
import { TranslateStringsModule } from "@components/translate-string";
import { CustomPipeModule } from "@components/custom-pipe/custom-pipe.module";
import { FilePickerModule } from "@components/file-picker";
import { DirectivesModule } from "@directives/directives.module";
import { ButtonModule } from "@components/button";
import { VideoPlayerModule } from "@components/video-player/video-player.module";
import { LoadingModule } from "@components/loading";
import { CameraModule } from "@components/camera";
import { PopUpModalModule } from "@components/pop-up-modal";
import { SwiperModule } from "swiper/angular";
import { WrongPhotoDetectedModule } from "@shared/bottom-sheet-layouts/wrong-photo-detected/wrong-photo-detected.module";
import { DeletePhotoSheetModule } from "@shared/bottom-sheet-layouts/delete-photo-sheet/delete-photo-sheet.module";
import { MouseTourModule } from "@components/mouse-tour";
import { ReadMoreComponent } from "@components/read-more/read-more.component";
import {
  SelectCheckupTypeComponent,
  CheckupPhotoInstructionComponent,
  CheckupListComponent,
  CheckupCaptureComponent,
  CheckupViewContainerComponent,
  HairAiReportComponent,
  CheckupViewExperimentComponent,
} from "./components";
import { ReportUploadSheetComponent } from "./components/select-checkup-type/report-upload-sheet/report-upload-sheet.component";
import {
  HairAiCanvasDirective,
  DrawImageDirective,
  ScrollToViewDirective,
  DrawDetectionsDirective,
} from "./directives";
import { onboardingGuard } from "../guards/onboarding.guard";
import { authenticationGuard } from "../guards/authentication.guard";
import { InstantCheckupLoaderComponent } from "@components/instant-checkup-loader/instant-checkup-loader.component";
import { ButtonCtaComponent } from "@components/button-cta/button-cta.component";
import { InvalidPhotoErrorCardComponent } from "./components/checkup-view-experiment/invalid-photo-error-card/invalid-photo-error-card.component";
import { ScalpParameterBarsComponent } from "./components/scalp-parameter-bars/scalp-parameter-bars.component";

@NgModule({
  declarations: [
    SelectCheckupTypeComponent,
    CheckupPhotoInstructionComponent,
    CheckupListComponent,
    CheckupCaptureComponent,
    CheckupViewContainerComponent,
    HairAiCanvasDirective,
    HairAiReportComponent,
    CheckupViewExperimentComponent,
    ScrollToViewDirective,
    DrawDetectionsDirective,
    ReportUploadSheetComponent,
  ],
  imports: [
    CommonModule,
    MouseTourModule,
    DrawImageDirective,
    RouterModule.forChild([
      {
        path: "instant-checkup",
        canActivate: [authenticationGuard, onboardingGuard],
        children: [
          { path: "", component: SelectCheckupTypeComponent },
          { path: "preview", component: CheckupPhotoInstructionComponent },
          { path: "capture", component: CheckupCaptureComponent },
          { path: "list", component: CheckupListComponent },
          { path: ":id", component: CheckupViewContainerComponent },
        ],
      },
    ]),
    ToolbarModule,
    FormsModule,
    RouterModule,
    TranslateStringsModule,
    CustomPipeModule,
    DirectivesModule,
    FilePickerModule,
    CsIconModule,
    ButtonModule,
    VideoPlayerModule,
    LoadingModule,
    CameraModule,
    PopUpModalModule,
    SwiperModule,
    DeletePhotoSheetModule,
    WrongPhotoDetectedModule,
    ReadMoreComponent,
    InstantCheckupLoaderComponent,
    ButtonCtaComponent,
    InvalidPhotoErrorCardComponent,
    ScalpParameterBarsComponent,
  ],
})
export class InstantCheckupModule {}
